"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.COOKIE_KEY_LOCALE = exports.MAP_LANG_TO_LOCALE = exports.MAP_LOCALE_TO_LANG = exports.SUPPORTED_LANGUGES = void 0;
var common_1 = require("@altus-ui/common");
var SUPPORTED_LANGUGES;
(function (SUPPORTED_LANGUGES) {
    SUPPORTED_LANGUGES["EN_US"] = "en-US";
    SUPPORTED_LANGUGES["KO_KR"] = "ko-KR";
})(SUPPORTED_LANGUGES || (exports.SUPPORTED_LANGUGES = SUPPORTED_LANGUGES = {}));
exports.MAP_LOCALE_TO_LANG = (_a = {},
    _a[common_1.Locale.en_US] = SUPPORTED_LANGUGES.EN_US,
    _a[common_1.Locale.ko_KR] = SUPPORTED_LANGUGES.KO_KR,
    _a);
exports.MAP_LANG_TO_LOCALE = {};
for (var locale in exports.MAP_LOCALE_TO_LANG) {
    exports.MAP_LANG_TO_LOCALE[exports.MAP_LOCALE_TO_LANG[locale]] = locale;
}
exports.COOKIE_KEY_LOCALE = 'x-altus-locale';
